import React, { useState } from 'react';
import './App.css';
import Navbar from './components/NavBar';
import ProtectedRoute from './components/ProtectedRoute';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Pages
import Home from './pages/home';
import About from './pages/about';
import LearnMore from './pages/learnMore';
import ArtistGallery from './pages/artistGallery';
import OrderForm from './pages/orderForm';
import VisualizationTool from './components/visualizationTool/visTool';
import Account from './pages/account';
import Checkout from './pages/checkout';
import CheckoutSuccess from './pages/checkoutSuccess';
import CheckoutFail from './pages/checkoutFail';
import ArtistPage from './pages/artistPage';
import Metrics from './pages/metrics';
import Users from './pages/users';
import Product from './pages/productPage';
import Orders from './pages/orderHistory';
import ArtistProfilePage from './pages/artistProfilePage';
import DimensionRequests from './pages/dimensionRequests';
import ArtistDashboard from './pages/artistDashboard';
import EmployeeDashboard from './pages/employeeDashboard';
import AdminDashboard from './pages/adminDashboard';
import Login from './pages/login';
import Register from './pages/register';
import VerifyEmail from './pages/verifyEmail';


function App() {
  const [scrollLock, setScrollLock] = useState(false);

  return (
    <Router>
      <RenderNavbar scrollLock={scrollLock} setScrollLock={setScrollLock} />
    </Router>
  );
}

function RenderNavbar({ scrollLock, setScrollLock }) {
  const location = useLocation();
  const hideNavbar = ['/artistPage', '/users','/metrics','/orderHistory','/productPage','/dimension-requests', '/artist-dashboard', '/employee-dashboard', '/admin-dashboard', '/login', '/register', '/verify-email'];
  // Check if path matches /artists/:artistId/dashboard pattern
  const isArtistDashboard = /^\/artists\/[^/]+\/dashboard$/.test(location.pathname);
  const includesNavbar = !hideNavbar.includes(location.pathname) && !isArtistDashboard;

  return (
    <>
      {includesNavbar && (
        <Navbar
          darkNavbar={location.pathname === '/frame-guide'}
          toggleScrollLock={() => {
            setScrollLock(!scrollLock);
            console.log("scrollLock = ", !scrollLock);
          }}
        />
      )}

      <Routes>
        <Route path='/' element={<Home scrollLock={scrollLock} />} />
        <Route path='/about' element={<About scrollLock={scrollLock} />} />
        <Route path='/frame-guide' element={<LearnMore scrollLock={scrollLock} />} />
        <Route path='/order-form' element={<OrderForm scrollLock={scrollLock} />} />
        <Route path='/artist-gallery' element={<ArtistGallery scrollLock={scrollLock} />} />
        <Route path='/visualizationTool' element={<VisualizationTool scrollLock={scrollLock} />} />
        <Route path='/account' element={<Account scrollLock={scrollLock} />} />
        <Route path='/checkout' element={<Checkout scrollLock={scrollLock} />} />
        <Route path='/checkoutSuccess' element={<CheckoutSuccess scrollLock={scrollLock} />} />
        <Route path='/checkoutFail' element={<CheckoutFail scrollLock={scrollLock} />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/verify-email' element={<VerifyEmail />} />
        
        {/* Protected Admin Routes */}
        <Route path='/artistPage' element={<ProtectedRoute requiredRole={['admin', 'employee']}><ArtistPage scrollLock={scrollLock} /></ProtectedRoute>} />
        <Route path='/metrics' element={<ProtectedRoute requiredRole={['admin', 'employee']}><Metrics scrollLock={scrollLock} /></ProtectedRoute>} />
        <Route path='/users' element={<ProtectedRoute requiredRole={['admin', 'employee']}><Users scrollLock={scrollLock} /></ProtectedRoute>} />
        <Route path='/productPage' element={<ProtectedRoute requiredRole={['admin', 'employee']}><Product scrollLock={scrollLock} /></ProtectedRoute>} />
        <Route path='/orderHistory' element={<ProtectedRoute requiredRole={['admin', 'employee']}><Orders scrollLock={scrollLock} /></ProtectedRoute>} />
        <Route path='/dimension-requests' element={<ProtectedRoute requiredRole={['admin', 'employee']}><DimensionRequests scrollLock={scrollLock} /></ProtectedRoute>} />
        {/* Protected Admin Routes */}
        <Route path='/admin-dashboard' element={<ProtectedRoute requiredRole="admin"><AdminDashboard scrollLock={scrollLock} /></ProtectedRoute>} />
        {/* Protected Employee Routes */}
        <Route path='/employee-dashboard' element={<ProtectedRoute requiredRole="employee"><EmployeeDashboard scrollLock={scrollLock} /></ProtectedRoute>} />
        {/* Public Routes */}
        <Route path='/artistProfilePage/:artistId' element={<ArtistProfilePage scrollLock={scrollLock} />} />
        {/* Artist Dashboard - Updated to use artist-specific URL */}
        <Route path='/artists/:artistId/dashboard' element={<ArtistDashboard scrollLock={scrollLock} />} />
        {/* Legacy route - redirect to new pattern for backwards compatibility */}
        <Route path='/artist-dashboard' element={<ArtistDashboard scrollLock={scrollLock} />} />
      </Routes>
    </>
  );
}

export default App;